import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import ListGroup from 'react-bootstrap/ListGroup';
import DataBrowseTable from './DataBrowseTable.js';
import { useRef } from 'react';


function DatasetTableauModal(props) {
    const typeIcons = {
        'Numeric': <i className='las la-hashtag' />,
        'Text': <i className='las la-quote-right' />,
        'Date/Time': <i className='las la-calendar' />
    }
    const {
        datasetName, description,
        domain, lastUpdated, filename, schema_filename, fields, sources 
    } = props.metadata;
    const {
        modalThumbnailURL,
        metadataLinks,
        metadataDescription
    } = props;
    const dateTokens = lastUpdated?.split(/\s+/);
    const updateDate = dateTokens?.length > 0 ? (
        `${dateTokens[0]}, ${dateTokens[1]} ${dateTokens[2]} ${dateTokens[4]}` +
        ` @ ${dateTokens[3]} ${dateTokens[5]}`
    ): 0;
    const iframeRef = useRef(null);

    return (
        <Modal show={props.show} onHide={props.handleClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ color: '#05436E', fontSize: '1.3rem' }}>{datasetName}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingTop: '2px',
            }}>
                <Tabs>
                    <Tab eventKey="overview" title="Preview">
                        {/* <div style={{ width: "75%", margin: '0 auto' }}>
                            <tableau-viz
                                title={datasetName + '_modal'}
                                src={tableauURL} 
                                seamless style={{ 
                                    height: '450px', 
                                    width: '75%', 
                                    marginTop: '1em', 
                                    marginBottom: '1em', 
                                    marginLeft: '12%',
                                    frameBorder: '0',
                            }}
                            ></tableau-viz>
                        </div> */}
                        <div style= {{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div className="text-content">
                                {metadataDescription}
                            </div>
                            <div className="image-container-lg" style={{ backgroundImage: `url(${modalThumbnailURL})`, }}></div>
                        </div>
                    </Tab>
                    <Tab eventKey="raw_data" title="Data">
                        <div style={{ margin: '0 auto', width: '85%' }}>
                            <p className="metadata-view-p" style={{ fontSize: "17px", fontWeight: 'bold', paddingTop: "24px" }}>
                                {metadataLinks}
                            </p>
                            <p className="metadata-view-p" style={{ fontSize: "16px", color: "#777" }}>
                                {/* Description: {description} */}
                            </p>
                            {/* <p className="metadata-view-p" style={{ fontStyle: 'italic', fontSize: "16px", color: "#777" }}>Last Updated: {updateDate}</p> */}
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}


export default DatasetTableauModal;